import script from "./EventView.vue?vue&type=script&setup=true&lang=js"
export * from "./EventView.vue?vue&type=script&setup=true&lang=js"

import "./EventView.vue?vue&type=style&index=0&id=148b8bf6&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-148b8bf6"]])

export default __exports__